import { useState } from 'react'
import type { Locale } from '../data/schema'
import { relationshipColors, relationshipTypes } from '../graphTokens'
import { copy } from '../i18n'

interface RelationshipLegendProps {
  locale: Locale
}

export function RelationshipLegend({ locale }: RelationshipLegendProps) {
  const [expanded, setExpanded] = useState(false)
  const t = copy[locale]
  const title = t.relationshipColorLegend

  return <section className={`relationship-legend${expanded ? ' expanded' : ''}`} aria-label={title}>
    <span className="relationship-legend-heading">
      <i aria-hidden="true" />
      {title}
    </span>
    <button
      type="button"
      className="relationship-legend-toggle"
      onClick={() => setExpanded((value) => !value)}
      aria-expanded={expanded}
    >
      <i aria-hidden="true" />
      {title}
    </button>
    <div className="relationship-legend-items">
      <span className="relationship-legend-item neutral-bundle">
        <i aria-hidden="true" />
        <span>{locale === 'en' ? 'Story/version links' : '故事／版本限定連結'}</span>
      </span>
      {relationshipTypes.map((type) => <span key={type} className="relationship-legend-item">
        <i aria-hidden="true" style={{ backgroundColor: relationshipColors[type] }} />
        <span>{t.edgeTypes[type]}</span>
      </span>)}
    </div>
  </section>
}
